import { StoreCommonService } from './../../../../services/store/store-common.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoyaltyAcmService } from 'app/services/loyalty/loyalty-acm.service';
import { LoyaltyReportService } from 'app/services/loyalty/loyalty-report.service';
import { SelectItem } from 'primeng/primeng';
import * as moment from 'moment';

@Component({
  selector: 'app-loyalty-report-form',
  templateUrl: './loyalty-report-form.component.html',
  styleUrls: ['./loyalty-report-form.component.css']
})
export class LoyaltyReportFormComponent implements OnInit {
  form: FormGroup;
  acmList: SelectItem[] = [];
  storeGroupList: SelectItem[] = [];
  storeChainList: SelectItem[] = [];
  storeList: SelectItem[] = [{label: '', value: null}];
  startDate: Date;
  endDate: Date;
  invalidSubmit = false;
  @Output() onCloseModal: EventEmitter<any> = new EventEmitter();
  @Output() onSaveReport: EventEmitter<any> = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    private loyaltyAcmService: LoyaltyAcmService,
    private storeCommonService: StoreCommonService,
    private reportService: LoyaltyReportService,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      code: ['', Validators.required],
      description: [''],
      storeTotal: true,
      chainTotal: true,
      acm: [''],
      storeGroup: [[]],
      storeChain: [[]],
      store: [''],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required]
    });
    this.loyaltyAcmService.getAllAcm().subscribe(res => {
      this.acmList = [{label: '', value: null}, ...res.map(acm => ({ label: acm.acmDescription, value: acm.id }))];
    });
    this.storeCommonService.getGroupList().subscribe(res => {
      this.storeGroupList = res.map(group => ({ label: group.name, value: group.id }));
    });
    this.reportService.getStoreChains().subscribe(res => {
      this.storeChainList = res.map(chain => ({ label: chain.name, value: chain.id }));
    });

  }

  onSelectionChange() {
    const selectedGroups = this.form.get('storeGroup').value;
    const selectedChains = this.form.get('storeChain').value;
    // Se un Gruppo selezionato
    if (selectedGroups.length === 1) {
      // Popolo gli Store con quelli del Gruppo
      const selectedGroupId = selectedGroups[0];
      this.storeCommonService.getListFilteredByStoreGroup(selectedGroupId).subscribe(res => {
        this.storeList = [...this.storeList, ...res.map(store => ({ label: store.name, value: store.id }))];
      });
    }
    // Se una Catena selezionata
    else if (selectedChains.length === 1) {
      // Popolo gli Store con quelli della Catena
      const selectedChainId = selectedChains[0];
      this.reportService.getStoresFromChain(selectedChainId).subscribe(res => {
        this.storeList = [...this.storeList, ...res.map(store => ({ label: store.storeName, value: store.id }))];
      });
    }
    // Se nessun o piú di un gruppo o catena selezionati
    else {
      // Pulisco eventuali Store selezionati
      this.form.get('store').setValue('');
      // Pulisco la Lista degli Store
      this.storeList = [{ label: '', value: null }];
    }
  }


  saveReport() {
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    const data = {
      ...this.form.value,
      startDate: moment(this.form.get('startDate').value).format('YYYY-MM-DD'),
      endDate: moment(this.form.get('endDate').value).format('YYYY-MM-DD'),
      startDateValue: moment.utc(this.form.get('startDate').value).toISOString(),
      endDateValue: moment.utc(this.form.get('endDate').value).toISOString()
    }
    this.reportService.saveReport(data).subscribe(() => this.onSaveReport.emit());
  }

  closeModal() {
    this.onCloseModal.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-report-list/loyalty-report-form/loyalty-report-form.component.ts